const React = require('react');
const Immutable = require('seamless-immutable');
const classnames = require('classnames');
const ActiveSelect = require('../../mui/select/active-select.jsx');
const DishPropsOption = require('./dish-props-option.jsx');

import { formatMessage } from '../../../intl/helper';
import dishMenuMessages from '../../../intl/messages/dish-menu';
import dishMessages from '../../../intl/messages/dish';

require('./dish-props-select.scss');

module.exports = React.createClass({
  displayName: 'DishPropsSelect',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    dishData: React.PropTypes.object,
    sameRuleList: React.PropTypes.array,
    checkedRuleIds: React.PropTypes.object,
    disabledRuleIdMap: React.PropTypes.object,
    onSelectPropsOption: React.PropTypes.func,
    onDishRuleChecked: React.PropTypes.func,
    showMemberPriceInfo: React.PropTypes.bool,
  },
  onSelectPropsOption(recipeData, optionData) {
    this.props.onSelectPropsOption(recipeData, optionData);
  },
  onDishRuleChecked(categoryId, id) {
    const { onDishRuleChecked } = this.props;
    onDishRuleChecked(categoryId, id);
  },
  getChangeShowDataItemsOrder(order) {
    if (Array.isArray(order) && order.length) {
      return order[0].count;
    } else if (Array.isArray(order) && !order.length) {
      return null;
    }

    return order;
  },
  buildRule(dish) {
    const { sameRuleList = [], checkedRuleIds = {}, disabledRuleIdMap = {} } = this.props;
    if (!sameRuleList.length) {
      return false;
    }

    const rules = sameRuleList;
    const buildRuleProperties = rule => {
      const { list: properties, id: categoryId } = rule;
      const propertyMap = {};
      // 已经有排序了的
      return properties
        .sort((a, b) => a.sort - b.sort)
        .map(prop => {
          if (propertyMap.hasOwnProperty(prop.id)) {
            return false;
          }

          const { id } = prop;
          const checked = checkedRuleIds[categoryId] === id;
          const disabled = disabledRuleIdMap[id];
          propertyMap[prop.id] = true;
          return (
            <button
              className={classnames('dish-porps-option', { 'is-checked': checked, 'is-disable': disabled })}
              onTouchTap={evt => this.onDishRuleChecked(categoryId, id)}
              key={id}
            >
              <span className="extra">{prop.reprice ? `+${sessionStorage.getItem('currency')}${prop.reprice}` : false}</span>
              <span className="name ellipsis">{prop.name}</span>
            </button>
          );
        });
    };
    return rules.map(ruleItem => {
      const { id } = ruleItem;
      return (
        <div className="recipe-group clearfix" key={id}>
          <span className="recipe-title">{`${ruleItem.name}(${formatMessage(dishMessages.dishrequired)})`}</span>
          {buildRuleProperties(ruleItem)}
        </div>
      );
    });
  },
  buildRecipe(props) {
    const { showMemberPriceInfo } = this.props;
    const recipesData = props.filter(propData => propData.type === 1);
    if (recipesData.length === 0) {
      return false;
    }

    return recipesData.map(recipeData => (
      <div className="recipe-group" key={recipeData.id}>
        <span className="recipe-title">
          {recipeData.name}
          {recipeData.isMandatory === 1 && <span>({formatMessage(dishMessages.dishrequired)})</span>}
        </span>
        <ActiveSelect
          className="clearfix"
          optionsData={recipeData.properties}
          sendSubComponentParam={{ showMemberPriceInfo }}
          optionComponent={DishPropsOption}
          onSelectOption={(evt, optionData) => this.onSelectPropsOption(recipeData, optionData)}
        />
      </div>
    ));
  },
  buildNote(props) {
    const { showMemberPriceInfo } = this.props;
    const notesData = props.filter(propData => propData.type === 3);
    if (notesData.length === 0) {
      return false;
    }

    return notesData.map(noteData => (
      <div className="note-group" key={noteData.id}>
        <span className="note-title">{noteData.name}</span>
        <ActiveSelect
          className="clearfix"
          optionsData={noteData.properties}
          optionComponent={DishPropsOption}
          sendSubComponentParam={{ showMemberPriceInfo }}
          onSelectOption={(evt, optionData) => this.onSelectPropsOption(noteData, optionData)}
        />
      </div>
    ));
  },
  buildIngredient(ingredients) {
    const { showMemberPriceInfo } = this.props;
    const wrappedIngredientsData = Immutable.from([{ name: formatMessage(dishMenuMessages.ingredients), type: -1, properties: ingredients }]);
    if (wrappedIngredientsData[0].properties.length === 0) {
      return false;
    }
    return wrappedIngredientsData.map(wrappedIngredientData => (
      <div className="ingredient-group" key={'ingredient'}>
        <span className="ingredient-title">{wrappedIngredientData.name}</span>
        <ActiveSelect
          className="clearfix"
          optionsData={wrappedIngredientData.properties}
          optionComponent={DishPropsOption}
          sendSubComponentParam={{ showMemberPriceInfo }}
          onSelectOption={(evt, optionData) => this.onSelectPropsOption(wrappedIngredientData, optionData)}
        />
      </div>
    ));
  },
  render() {
    const { dish } = this.props;
    const ruleElement = this.buildRule(dish);
    const propertyVisible = Array.isArray(dish.order);
    const recipeElement = propertyVisible ? this.buildRecipe(dish.order[0].dishPropertyTypeInfos || []) : false;
    const noteElement = propertyVisible ? this.buildNote(dish.order[0].dishPropertyTypeInfos || []) : false;
    const buildIngredientElement = propertyVisible ? this.buildIngredient(dish.order[0].dishIngredientInfos || []) : false;

    return (
      <div className="dish-props-select o-flex__fluid">
        {ruleElement}
        <div className="clearfix" />
        {recipeElement}
        {buildIngredientElement}
        {noteElement}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/dish-props-select.jsx